import { TModifierGroupAction, ModifierGroupActionTypes } from './modifierGroupsActions';
import { IModifierGroupState } from './modifierGroupContext';

export const modifierGroupReducer = (state: IModifierGroupState, action: TModifierGroupAction): IModifierGroupState => {
	switch (action.type) {
		case ModifierGroupActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ModifierGroupActionTypes.SET_MODIFIER_GROUPS:
			return {
				...state,
				modifierGroups: action.payload.modifierGroups,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.TOGGLE_REMEMBER_MY_CHOICE:
			return {
				...state,
				rememberMyChoice: action.payload.rememberMyChoice,
			};
		case ModifierGroupActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				modifierGroups: action.payload.modifierGroups,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ModifierGroupActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ModifierGroupActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS:
			return {
				...state,
				IDForAssignRestaurants: action.payload.IDForAssignRestaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.SET_ID_FOR_EDIT_RESTAURANT_PROPERTIES:
			return {
				...state,
				IDForEditRestaurantProperties: action.payload.IDForEditRestaurantProperties,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.SET_ID_FOR_EDIT_MODIFIERS_TEMPLATE:
			return {
				...state,
				IDForEditModifiersTemplate: action.payload.IDForEditModifiersTemplate,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifierGroupActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
				isInitializedSelectCustomerModal: true,
			};
		default:
			return state;
	}
};
